import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/pipe/safe-html.pipe.ts